import { NgModule } from '@angular/core';
import { provideRouter } from '@angular/router';

@NgModule({
  providers: [
    provideRouter([
      {
        path: 'admin-dashboard',
        redirectTo: '/system-admin',
        pathMatch: 'full',
      },
    ]),
  ],
})
export class AdminDashboardRoutingModule {}
